import { render } from "./imgAppViVimass.vue?vue&type=template&id=7735123e&scoped=true"
import script from "./imgAppViVimass.vue?vue&type=script&lang=js"
export * from "./imgAppViVimass.vue?vue&type=script&lang=js"

import "./imgAppViVimass.vue?vue&type=style&index=0&id=7735123e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7735123e"]])

export default __exports__